import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Table } from 'react-bootstrap';
import { CurrencyPlainText, CurrencyDollarPlainText, CurrencyEuroPlainText } from 'helpers/Currency';
import { api } from 'services';

const ActionsMarginResume = ({ actionId, isValueCompproved, currency }) => {
  const [total, setTotal] = useState(0);
  const [margin, setMargin] = useState(0);
  const [expense, setExpense] = useState(0);
  const [expireValue, setExpireValue] = useState(0);
  const [realValues, setRealValues] = useState(null);
  const [id, setId] = useState(actionId)
  const [carregou, setCarregou] = useState(false);
  useEffect(() => async () => {
    if(!carregou){
      setCarregou(true);  
      await api.get(`action-margin/${id}`).then(({ data }) => {
        setTotal(data.value);
        setExpense(data.expense > 0 ? data.expense : data.expenseExpected);
        setExpireValue(data.expire);
        setMargin(data.expense > 0 ? data.margin : data.marginExpected);
  
        if(data.isOtherCurrency){
          setRealValues({
            total: data.valueReal,
            expense: data.expenseReal > 0 ? data.expenseReal : data.expenseExpectedReal,
            expire: data.expireReal,
            margin: data.marginReal > 0 ? data.marginReal : data.marginExpectedReal
          });
        }
        
      });
    }
  });

  const getCurrency = (value, forceCurrency = null) => {
    switch (forceCurrency?forceCurrency:currency) {
      case '1':
        return <CurrencyPlainText value={value} />;
        break;
      case '2':
        return <CurrencyDollarPlainText value={value} />;
        break;
      case '3':
        return <CurrencyEuroPlainText value={value} />;
        break;
      default:
        break;
    }
  };

  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col>
          <Row>
            <Col>
              <label>{t('title:resume')}</label>
            </Col>
          </Row>
          <Table bordered responsive>
            <thead>
              <tr>
                <th className="text-center align-middle">
                  {t('label:action value')}
                </th>

                <th className="text-center align-middle">
                  {t(isValueCompproved ? 'label:real spent' : 'label:expected spent')}
                </th>
                
                <th className="text-center align-middle">
                  {t('label:action expire value')}
                </th>

                <th className="text-center align-middle">
                  {t(isValueCompproved ? 'label:real margin' :'label:expected margin')}
                </th>
                
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center align-middle">
                  {getCurrency(total)}
                  {/* <CurrencyPlainText value={total} /> */}
                </td>
                <td className="text-center align-middle">
                  {getCurrency(expense)}
                  {/* <CurrencyPlainText value={expense} /> */}
                </td>
                <td className="text-center align-middle">
                  {getCurrency(expireValue)}
                  {/* <CurrencyPlainText value={expireValue} /> */}
                </td>
                <td className="text-center align-middle">
                  {getCurrency(margin)}
                  {/* <CurrencyPlainText value={margin} /> */}
                </td>
              </tr>
              {realValues?(
                <tr>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.total,'1')}
                    {/* <CurrencyPlainText value={total} /> */}
                  </td>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.expense,'1')}
                    {/* <CurrencyPlainText value={expense} /> */}
                  </td>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.expire,'1')}
                    {/* <CurrencyPlainText value={expireValue} /> */}
                  </td>
                  <td className="text-center align-middle">
                    {getCurrency(realValues.margin,'1')}
                    {/* <CurrencyPlainText value={margin} /> */}
                  </td>
                </tr>
              ):''}
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
};

export default ActionsMarginResume;
